var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchMapSolid = function SvgSearchMapSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M9 4 3.068 5.977A.1.1 0 0 0 3 6.072v14.79a.1.1 0 0 0 .132.094L9 19V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "m9 3.368 6 2 5.679-1.893a.7.7 0 0 1 .921.664V11h-1.2V4.832l-4.8 1.6V9h-1.2V6.432l-4.8-1.6v14.6l-6.279 2.093a.7.7 0 0 1-.921-.664V6.072a.7.7 0 0 1 .479-.664L9 3.368Zm-.6 1.464v13.735l-4.8 1.6V6.433l4.8-1.6Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M20.067 16.033a4.033 4.033 0 1 1-8.067 0 4.033 4.033 0 0 1 8.067 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#080808",
    strokeWidth: 1.52,
    d: "M18.885 18.885 23 23m-2.933-6.967a4.033 4.033 0 1 1-8.067 0 4.033 4.033 0 0 1 8.067 0Z"
  })));
};
export default SvgSearchMapSolid;